// shared utils/roomLabelUtils.js
export function getRoomLabel(room) {
  const house = String(room.house || "").trim();
  const name =
    room.groupName ||
    room.roomName ||
    room.bedroomName ||
    "Room";

  if (house && name) return `${house} · ${name}`;
  if (house) return house;
  return name;
}
